module.exports = __webpack_public_path__ + "img/graph2.339d3459.png";